module.exports = __webpack_public_path__ + "static/resume-17086ec0f154fc884b69eb3382ebe503.pdf";